module.exports = __webpack_public_path__ + "static/media/Swoobat_gaussian2.08a91132.png";